import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { LayoutSingleColumn, Page } from '../../components';
import { connect } from 'react-redux';
import { bool } from 'prop-types';
import { useIntl } from 'react-intl';
import loadable from '@loadable/component';
import { useConfiguration } from '../../context/configurationContext';
import {
  categoryItems,
  discoverColumns,
  jobTypeItems,
  testimonialItems,
} from './LawyerLandingPage.constant';
import { facebookImageURL, twitterImageURL } from '../../config/configBranding';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import SectionHero from './SectionHero/SectionHero';
import SectionHowItWorks from './SectionHowItWorks/SectionHowItWorks';
import SectionPartners from './SectionPartners/SectionPartners';
import SectionJobTypes from './SectionJobTypes/SectionJobTypes';
import SectionDiscover from './SectionDiscover/SectionDiscover';

const SectionCategories = loadable(() => import('./SectionCategories/SectionCategories'), {
  ssr: false,
});

const SectionTestimonials = loadable(() => import('./SectionTestimonials/SectionTestimonials'), {
  ssr: false,
});

import css from './LawyerLandingPage.module.css';

const LawyerLandingPage = props => {
  const { scrollingDisabled } = props;

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const config = useConfiguration();

  const schemaTitle = intl.formatMessage(
    { id: 'LawyerLandingPage.schemaTitle' },
    { siteTitle: config.marketplaceNamw }
  );
  const schemaDescription = intl.formatMessage({ id: 'LawyerLandingPage.schemaDescription' });
  const schemaImage = `${facebookImageURL}`;

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImageURL, width: 1200, height: 630 }]}
      twitterImages={[{ url: twitterImageURL, width: 600, height: 314 }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="LawyerLandingPage" />}
        footer={<FooterComponent />}
      >
        <div className={css.content}>
          <SectionHero history={history} routeConfiguration={routeConfiguration} />
          <SectionHowItWorks />
          <SectionCategories items={categoryItems} />
          <SectionPartners />
          <SectionJobTypes items={jobTypeItems} />
          <SectionTestimonials items={testimonialItems} />
          <SectionDiscover config={config} columnContent={discoverColumns} />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

LawyerLandingPage.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(LawyerLandingPage);
